import React, { JSX } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  resetMapModifyLocation,
  setSearchLocationMap,
  setSideBarGeoLocOpenClose,
  setSearchSidebarOpenClose,
  setSidebarViews,
  setViewValues,
} from "../../../redux/slices/map/map";

import StarIcon from "@mui/icons-material/Star";
import SearchIcon from "@mui/icons-material/Search";

import { State } from "../../../redux/slices";
import { ThunkDispatch } from "@reduxjs/toolkit";
import { ChipInarixMap } from "../../overview/OverviewStyles";
import { getMapViews } from "../../../redux/actions/map/mapAsyncActions";
import DateRangePickerWithButtonField from "../mapActivityRangePicker/MapActivityRangePicker";
import { inarixColors } from "inarix-theme";

const SetActions = () => {
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
  return {
    modifyLocationFalse: () => dispatch(resetMapModifyLocation()),
    sideBarSearchOpen: () => {
      dispatch(setSearchSidebarOpenClose(true));
      dispatch(setSideBarGeoLocOpenClose(false));
    },

    setValue: (value: string) => dispatch(setSearchLocationMap(value)),

    setSidebarViews: (open: boolean, token: string) => {
      dispatch(setSidebarViews(open));
      dispatch(getMapViews(token));
      dispatch(setViewValues({ nameView: "", viewDescription: "", email: "" }));
    },
  };
};

const OverviewUniversalPanel = (
  t: (arg0: string) => string,
  token: string
): JSX.Element => {
  const {
    modifyLocation,
    createLocationActive,
    sidebarGeoLoc,
    sideBarViews,
    sidebarSearch,
  } = useSelector((state: State) => state.MapReducer);

  const { layoutActive } = useSelector((state: State) => state.LayoutReducer);

  const { sideBarSearchOpen, setSidebarViews } = SetActions();

  const chipsPosition = () => {
    if (!layoutActive) {
      return "position-button-panel";
    } else {
      return "position-button-panel-open";
    }
  };

  const leyendPanel = (color: string, leyend: string) => {
    return (
      <div className="leyend-pos">
        <div className="div-leyend" style={{ background: color }} />
        <span className="leyend-font-style">{leyend}</span>
      </div>
    );
  };
  const panelTool = () => {
    return (
      <div
        className="panel-tool-map-features"
        style={{
          display: "flex",
          flexWrap: "wrap",
          alignItems: "center",
          gap: "8px",
          width: "100%",
        }}
      >
        <div className={chipsPosition()}>
          <div
            className="panel-container-options"
            style={{
              display: "flex",
              flexWrap: "wrap",
              alignItems: "center",
              gap: "7px",
              width: "100%",
            }}
          >
            {!createLocationActive &&
            !sidebarGeoLoc &&
            !sidebarSearch &&
            !sideBarViews &&
            !modifyLocation ? (
              <>
                <ChipInarixMap
                  onClick={sideBarSearchOpen}
                  data-cy="search-button"
                  icon={<SearchIcon className="icon-chip-overview" />}
                  label={t("Fleet_overview.overview_panel.chips.Search")}
                />

                <ChipInarixMap
                  data-cy="views-button"
                  onClick={() => setSidebarViews(true, token)}
                  icon={<StarIcon className="icon-chip-overview" />}
                  label={t("Fleet_overview.overview_panel.chips.My_views")}
                />
              </>
            ) : (
              <div className="spacer-options-map" />
            )}

            {DateRangePickerWithButtonField()}

            <div
              className="leyend-panel"
              style={{
                display: "flex",
                gap: "4px",
                flexShrink: 0,
              }}
            >
              {leyendPanel(
                inarixColors.locationWithActivityBackground,
                t("Fleet_overview.overview_panel.leyend_active_user")
              )}
              {leyendPanel(
                inarixColors.locationWithoutActivityBackground,
                t("Fleet_overview.overview_panel.leyend_inactive_user")
              )}
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="overview-panel-div">
      <div>{panelTool()}</div>
    </div>
  );
};

export default OverviewUniversalPanel;
